export default __webpack_public_path__ + "static/media/dementia-logo-white@2x.50c4b347.png";